import { PathsV2 } from 'core/services/navigation/pathsV2';
import { ExtractParamsInPath } from 'core/services/navigation/utils/extractParamsInPath';
import { NavigateFunction, NavigateOptions } from 'react-router-dom';
import { replaceParamsInPath } from 'core/services/navigation/utils/replaceParamsInPath';

type NavigateToPathType = {
  [K in keyof typeof PathsV2]: (
    params: ExtractParamsInPath<(typeof PathsV2)[K]>,
    navigateOptions?: NavigateOptions
  ) => void;
};

const buildPathWithSearchParams = <T extends string>(
  path: T,
  params: ExtractParamsInPath<T>
): string => {
  const replacedPathParams = replaceParamsInPath(path, params);

  const searchParams = (params as any).searchParams;
  if (!searchParams) {
    return replacedPathParams;
  }

  const passedSearchParams = Object.entries(searchParams);
  const definedSearchParams = passedSearchParams.filter(
    ([, value]) => value !== null && value !== undefined
  );

  if (definedSearchParams.length === 0) {
    return replacedPathParams;
  }

  const newUrlSearchParams = new URLSearchParams({});
  definedSearchParams.forEach(([k, v]) => {
    newUrlSearchParams.append(k, v as string);
  });
  return `${replacedPathParams}?${newUrlSearchParams.toString()}`;
};

export const createNavigateToPathFunctions = (
  navigate: NavigateFunction,
  factoryNavigateOptions?: NavigateOptions
) =>
  Object.fromEntries(
    (Object.keys(PathsV2) as Array<keyof typeof PathsV2>).map((key) => [
      key,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (params: any, navigateOptions?: NavigateOptions) => {
        const mergedOptions = { ...factoryNavigateOptions, ...navigateOptions };
        navigate(
          buildPathWithSearchParams(PathsV2[key], params),
          mergedOptions
        );
      }
    ])
  ) as NavigateToPathType;
